import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICheckedValue } from '@app/core/models/core-models';
import { CategoriesArrayCategory } from '../traffic-source-categories.component';

export interface CategoryCheckedFilter {
  values: number[];
  elementID: number;
  parentElement?: any;
}

@Component({
  selector: 'app-traffic-source-category-subelements',
  templateUrl: './traffic-source-category-subelements.component.html',
  styleUrls: ['./traffic-source-category-subelements.component.scss']
})
export class TrafficSourceCategorySubelementsComponent implements OnInit {
  @Input() element?: CategoriesArrayCategory;
  @Input() isEditMode: boolean = false;
  @Input() parentElement: any;
  @Input() checkedValues: number[];
  @Input() defaultValue: string = '';
  @Input() endpointParameterCategory: string = '';
  @Input() subsubElement: boolean = false;
  @Input() nestedSubelements: boolean = false;
  @Input() activeCategory: boolean = false;

  @Output() emitCheckedFilters: EventEmitter<CategoryCheckedFilter> = new EventEmitter();
  @Output() emitExpandAction: EventEmitter<CategoriesArrayCategory> = new EventEmitter();

  public finalArray: CategoriesArrayCategory[] = [];
  public currentlyCheckedElement?: ICheckedValue;

  public hideRuleContent: boolean[] = [];

  constructor() {}

  ngOnInit(): void {
    this.finalArray = this.element?.children ?? [];
    if (this.isEditMode) {
      this.setHideRuleContent(this.element?.children ?? []);
    }
  }

  public toggleExpandable(index: number): void {
    this.hideRuleContent[index] = !this.hideRuleContent[index];

    this.emitExpandAction.emit(this.element);
  }

  public checkboxValue(event: Event, index: number, element: CategoriesArrayCategory): void {
    this.currentlyCheckedElement = {
      id: element.id,
      index,
      quantity: element.quantity,
      childs: element.children as Omit<CategoriesArrayCategory, 'id'>[]
    };
    if ((event.target as HTMLInputElement).checked) {
      if (!this.checkedValues.includes(element.id)) {
        this.checkedValues.push(element.id);
      }
      if (element.children?.length) {
        element.children.map(child => {
          if (!this.checkedValues.includes(child.id)) {
            this.checkedValues.push(child.id);
          }
        });
      }
    } else {
      this.checkedValues = this.checkedValues.filter(el => el !== element.id);
      if (element.children?.length) {
        element.children.map(child => {
          if (this.checkedValues.includes(child.id)) {
            this.checkedValues = this.checkedValues.filter(el => el !== child.id);
          }
        });
      }
    }
    if (this.element) {
      this.emitCheckedFilters.emit({
        values: this.checkedValues,
        elementID: this.element.id,
        parentElement: this.parentElement
      });
    }
  }

  public getCheckedSubelements(arrayOfSubelements: CategoryCheckedFilter): void {
    // check if currently checked elements are all childs of parent element. If yes, parent element should also be checked
    const childsArray: number[] = [];
    if (arrayOfSubelements.parentElement.children?.length) {
      arrayOfSubelements.parentElement.children.map(child => {
        if (arrayOfSubelements.values.includes(child.id)) {
          childsArray.push(child.id);
        }
      });
      if (childsArray.length === arrayOfSubelements.parentElement.children.length) {
        arrayOfSubelements.values.push(arrayOfSubelements.parentElement.id);
      } else {
        arrayOfSubelements.values = arrayOfSubelements.values.filter(val => val !== arrayOfSubelements.parentElement.id);
      }
    }
    let checkedValues = [...arrayOfSubelements.values];
    checkedValues = [...new Set(checkedValues)];

    if (this.element) {
      this.emitCheckedFilters.emit({
        values: checkedValues,
        elementID: this.element.id
      });
    }
  }

  public countCheckedChildren(children: CategoriesArrayCategory[]): boolean {
    let counter = 0;
    children.map(el => {
      if (this.checkIfChecked(el.id)) {
        counter++;
      }
    });
    return children.length > counter && counter > 0;
  }

  public checkIfChecked(valueID: number): boolean {
    return this.checkedValues.some(element => element === valueID);
  }

  private setHideRuleContent(categoriesArr: CategoriesArrayCategory[]): void {
    this.hideRuleContent = categoriesArr.map(el => {
      if (el.children?.length) {
        return this.checkChildren(el.children);
      } else {
        return false;
      }
    });
  }

  private checkChildren(arr: CategoriesArrayCategory[]): boolean {
    let value = false;
    for (let el of arr) {
      if (el.checked === true) {
        value = true;
        break;
      }
    }
    return value;
  }
}
